'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCrmObjectLifecycleUpdateMetadata = undefined;

var _objectTypes = require('../constants/objectTypes');

var _TicketUpdateMetadata = require('../records/TicketUpdateMetadata');

var _TicketUpdateMetadata2 = _interopRequireDefault(_TicketUpdateMetadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildCrmObjectLifecycleUpdateMetadata = exports.buildCrmObjectLifecycleUpdateMetadata = function buildCrmObjectLifecycleUpdateMetadata(type, updateProps) {
  switch (type) {
    case _objectTypes.TICKET:
      return new _TicketUpdateMetadata2.default(updateProps);
    default:
      return null;
  }
};